export const defaultPadding = '1rem';